import { withAssets } from './with-assets'
import { withAuth } from './with-auth'
import { withContextMenu } from './with-context-menu'
import { withHashRouter } from './with-hash-router'
import { withKeyboard } from './with-keyboard'
import { withModalProvider } from './with-modal-provider'
import { withQueryClient } from './with-query-client'
import { withReduxProvider } from './with-redux'
import { withRpcProvider } from './with-rpc'
import { withSubscribe } from './with-subscribe'
import { withToastProvider } from './with-toast'

export default function compose(...funcs: any) {
	if (funcs.length === 0) {
		return (arg: any) => arg
	}

	if (funcs.length === 1) {
		return funcs[0]
	}

	return funcs.reduce(
		(a: (arg0: any) => any, b: (arg0: any) => any) =>
			(...args: any[]) =>
				// @ts-ignore
				a(b(...args))
	)
}

export const withProviders = compose(
	withHashRouter,
	withQueryClient,
	withRpcProvider,
	withToastProvider,

	withModalProvider,
	withContextMenu,
	withReduxProvider,
	withAuth,

	withSubscribe,
	withAssets,
	withKeyboard
)
